import lazy from "@codeArt/apps/lazy";
import ArrowForward from "@material-ui/icons/ArrowForward";
import DeveloperBoardOutlinedIcon from "@material-ui/icons/DeveloperBoardOutlined";
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';

export function getMenus(baseUrl){
  if(baseUrl.endsWith("/")) baseUrl=baseUrl.substr(0,baseUrl.length-1);

  return [
    {
      name: "用户及控制",
      type: "collapse",
      children: [
        {
          name: "用户管理",
          type: "section",
          children: [
            {
              name: "用户授权",
              icon: <ArrowForward />,
              type: "item",
              link: `${baseUrl}/auth/user/index`
            },
            {
              name: "角色管理",
              icon: <ArrowForward />,
              type: "item",
              link: `${baseUrl}/auth/user/role`
            }
          ]
        },
        {
          name: "功能模块",
          type: "section",
          children: [
            {
              name: "平台管理",
              icon: <ArrowForward />,
              type: "item",
              link: `${baseUrl}/auth/feature/platform`
            },
            {
              name: "模块管理",
              icon: <ArrowForward />,
              type: "item",
              link: `${baseUrl}/auth/feature/module`
            },
            {
              name: "功能设置",
              icon: <ArrowForward />,
              type: "item",
              link: `${baseUrl}/auth/feature/function`
            }
          ]
        },
        {
          name: "权限管理",
          type: "section",
          children: [
            {
              name: "权限范围",
              icon: <ArrowForward />,
              type: "item",
              link: `${baseUrl}/auth/permission/range`
            },
            {
              name: "权限",
              icon: <ArrowForward />,
              type: "item",
              link: `${baseUrl}/auth/permission/config`
            }
          ]
        }
      ]
    },
    {
      name: "开发者设置",
      icon: <DeveloperBoardOutlinedIcon />,
      type: "item",
      link: `${baseUrl}/auth/developer/index`
    },
    {
      name: "个人档案",
      icon: <AssignmentIndIcon />,
      type: "item",
      link: `${baseUrl}/auth/userinfo/index`
    }
  ];
}

export function getRoutes(baseUrl){
  if(baseUrl.endsWith("/")) baseUrl=baseUrl.substr(0,baseUrl.length-1);

  return [{
    path: `${baseUrl}/auth/permission/range`,
    component: lazy(() => import("@codeArt/apps/page/auth/permission/range"))
  },
  {
    path: `${baseUrl}/auth/permission/config`,
    component: lazy(() => import("@codeArt/apps/page/auth/permission/config"))
  },
  {
    path: `${baseUrl}/auth/feature/platform`,
    component: lazy(() => import("@codeArt/apps/page/auth/feature/platform"))
  },
  {
    path: `${baseUrl}/auth/feature/module`,
    component: lazy(() => import("@codeArt/apps/page/auth/feature/module"))
  },
  {
    path: `${baseUrl}/auth/feature/function`,
    component: lazy(() => import("@codeArt/apps/page/auth/feature/function"))
  },
  {
    path: `${baseUrl}/auth/user/role`,
    component: lazy(() => import("@codeArt/apps/page/auth/user/role/index"))
  },
  {
    path: `${baseUrl}/auth/user/index`,
    component: lazy(() => import("@codeArt/apps/page/auth/user/index"))
  },
  {
    path: `${baseUrl}/auth/developer/index`,
    component: lazy(() => import("@codeArt/apps/page/auth/developer/index"))
  },
  {
    path: `${baseUrl}/auth/userinfo/index`,
    component: lazy(() => import("@codeArt/apps/page/user/info/index"))
  }
  ]
}